import { styled } from "@mui/system";
import { InputBase } from "@mui/material";
import { createNamedStyles } from "../../shared/CreateNamedStyles";
import { ColorsEnum } from "../../shared/constants/enums/Colors";

export const SwaggerStyles = createNamedStyles({
  chipMethod: {
    color: "white",
    fontWeight: "bold",
    minWidth: "80px",
    width: "80px",
    height: "52px",
    borderRadius: "4px",
  },
  boxContainer: {
    backgroundColor: "#1F1F1F",
  },
  boxCollapse: {
    mt: 0,
    p: 2,
    backgroundColor: "#1F1F1F",
    borderRadius: 1,
  },
  IconButton: {
    color: "white",
    paddingLeft: 1,
    paddingRight: 2,
  },
  titleClass: {
    marginTop: 2,
    marginBottom: 2.5,
    fontWeight: "700",
    fontSize: "20px",
    color: "#FFFFFF",
  },
  responseTitle: {
    display: "ruby",
    fontWeight: "800",
    fontSize: "16px",
    color: "#FFFFFF",
  },
  responseValue: {
    fontWeight: "400",
    fontSize: "16px",
    color: "#FFFFFF",
  },
  titleContainers: {
    fontSize: "12px",
    fontWeight: "800",
    color: "white",
    letterSpacing: "1px",
  },
  bodyContainer: {
    color: "#C7C7C7",
    fontWeight: "500",
    fontSize: "16px",
  },
  gridTitle: {
    backgroundColor: "#8080801A",
    borderBottom: "1px solid #8080804D",
  },
  gridContainer: {
    backgroundColor: "#1F1F1F",
    borderBottom: "1px solid #8080804D",
  },
  radioButton: {
    color: "#fff",
    "&.Mui-checked": { color: "#fff" },
  },
  boxButtons: {
    display: "flex",
    gap: 2,
    mt: 3,
  },
  buttonRequest: {
    padding: "8px 16px",
    background: "#D53235",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
  buttonCollapse: {
    padding: "8px 16px",
    background: "#757575",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
  input: {
    "& .MuiOutlinedInput-root fieldset": {
      border: "0px",
    },
  },
  textField: {
    mb: 2,
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#1e1e1e",
      color: "#ffffff",
      fontFamily: 'Monaco, Consolas, "Courier New", monospace',
      fontSize: "12px",
      "& fieldset": {
        borderColor: "#444",
      },
      "&:hover fieldset": {
        borderColor: "#666",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#888",
      },
    },
    "& .MuiOutlinedInput-input": {
      color: "#ffffff",
      whiteSpace: "pre-wrap",
    },
  },
});

export const StyledInputBase = styled(InputBase)(() => ({
  "& .MuiSvgIcon-root": {
    color: "white",
  },
  background: "rgba(128, 128, 128, 0.3)",
  borderColor: "rgba(128, 128, 128, 0.3)",
  borderRadius: "4px",
  input: {
    color: "#000000ff",
    minHeight: "40px",
    minWidth: "200px",
    fontWeight: 700,
    fontSize: "16px",
    "&::placeholder": {
      color: ColorsEnum["#C7C7C7"],
    },
  },
  "& label.Mui-focused": {
    color: ColorsEnum["#FCFCFC"],
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: ColorsEnum["#FCFCFC"],
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "rgba(128, 128, 128, 0.3)",
    },
    "&:hover fieldset": {
      borderColor: ColorsEnum["#FCFCFC"],
    },
    "&.Mui-focused fieldset": {
      borderColor: ColorsEnum["#FCFCFC"],
    },
  },
  "& .MuiInputBase-input": {
    minWidth: 200,
    borderRadius: 4,
    position: "relative",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    "&:focus": {
      borderRadius: 4,
      color: ColorsEnum["#FCFCFC"],
    },
  },
  "& .MuiSelect-select": {
    color: ColorsEnum["#FCFCFC"],
  },
  "& .MuiMenuItem-root": {
    color: "#000000ff",
  },
}));
